// 商务审批模块只读控制：销售侧角色（SALES_MANAGER、SALES）可进入审批页面查看详情，
// 但不能执行审核提交、导出、新增等写操作，菜单可见范围由 leftNavData 的 role 决定，
// 红点数量不在 needRedDoltInfo 中登记，因此这两个角色不会发起红点查询。
// 局部例外：页面声明组件选项 auditViewOnlyExclude: ['XXX'] 即可让该角色在本页面保持完整审批权限。
import {getDataInLocalStorage} from "@/utils/localStorage";

export const AUDIT_VIEW_ONLY_ROLES = ['SALES_MANAGER', 'SALES'];

export const auditViewOnlyMixin = {
    computed: {
        // 当前登录角色是否只能查看详情
        // 页面可通过组件选项 auditViewOnlyExclude 声明本页面的例外角色（保持完整审批权限与标签页红点）
        isAuditViewOnly() {
            const role = getDataInLocalStorage('role');
            const exclude = this.$options.auditViewOnlyExclude || [];
            if (exclude.includes(role)) return false;
            return AUDIT_VIEW_ONLY_ROLES.includes(role);
        }
    }
}
